import { useEffect } from 'react'
import Router from 'next/router'

export const BODY_LOCK_CLASSES = ['modal-open-mob']

/**
 * Deja el body en estado "scrolleable". Varios paneles (filtros, orden,
 * buscador) bloquean el scroll con `position: fixed` en el body y lo restauran
 * al cerrarse; si la ruta cambia con el panel abierto el bloqueo sobrevive y
 * la página destino queda clavada arriba.
 */
export const resetBodyScrollLock = (): void => {
    if (typeof document === 'undefined') return
    const { body } = document
    if (body.style.position === 'fixed') {
        body.style.position = ''
        body.style.top = ''
        body.style.left = ''
        body.style.right = ''
        body.style.width = ''
        body.style.overflow = ''
    }
    BODY_LOCK_CLASSES.forEach((className) => body.classList.remove(className))
}

/** Red de seguridad: tras cada navegación completa (no shallow) libera el body. */
export const useBodyScrollLockReset = (): void => {
    useEffect(() => {
        const handleRouteChangeComplete = (
            _url: string,
            options?: { shallow?: boolean }
        ) => {
            if (options?.shallow) return
            resetBodyScrollLock()
        }
        Router.events?.on?.('routeChangeComplete', handleRouteChangeComplete)
        return () => {
            Router.events?.off?.(
                'routeChangeComplete',
                handleRouteChangeComplete
            )
        }
    }, [])
}
